import { Form, Input, message, Modal } from "antd";
import React, { useState } from "react";
import type { VolunteerStore } from "../store";

interface Props {
  store: VolunteerStore;
  target: { slotId?: string; taskId?: string };
  title: string;
  open: boolean;
  onClose: () => void;
}

export const EmailContactsModal = ({ store, target, title, open, onClose }: Props) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleOk = async () => {
    const values = await form.validateFields();
    setSubmitting(true);
    try {
      await store.emailContacts(target, values.targetEmail);
      message.success("Kontaktdaten wurden per E-Mail versendet.");
      form.resetFields();
      onClose();
    } catch (e: any) {
      message.error(e?.message ?? "Versand fehlgeschlagen.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title={`Kontaktdaten per E-Mail senden: ${title}`}
      okText="Senden"
      cancelText="Abbrechen"
      confirmLoading={submitting}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="targetEmail"
          label="Ziel-E-Mail-Adresse"
          rules={[
            { required: true, message: "Bitte E-Mail-Adresse eingeben" },
            { type: "email", message: "Bitte gültige E-Mail eingeben" },
          ]}
        >
          <Input type="email" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
